import { FC } from "react";
import TargetAssignmentSvg from "../../public/icons/TargetAssignment.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const TargetAssignmentIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><TargetAssignmentSvg/></span>;
